export const EMAIL_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

export const PHONE_REGEX = /^\([0-9]{3}\) [0-9]{3}-[0-9]{4}$/;

export const SUPERVISOR_PHONE_REGEX = /^[0-9]{3}-[0-9]{3}-[0-9]{4}$/;
